import React, { useState } from "react";
import NavBar from "../Components/Navbar";
import {
  Badge,
  Button,
  Card,
  Col,
  Container,
  Image,
  ListGroup,
  Modal,
  Row,
  Table,
} from "react-bootstrap";
import Lightbox from "react-image-lightbox";

import "react-image-lightbox/style.css";

const Charters = () => {
  const [showExpertModal, setShowExpertModal] = useState(false);
  const handleShow = () => setShowExpertModal(true);
  const handleClose = () => setShowExpertModal(false);
  const [isOpen, setIsOpen] = useState(false);
  const images = [
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_001.jpeg",
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_002.jpeg",
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_003.jpeg",
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_004.jpeg",
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_005.jpeg",
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_006.jpeg",
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_007.jpeg",
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_008.jpeg",
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_009.jpeg",
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_0010.jpeg",
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_0011.jpeg",
    "https://ayg.s3.us-east-2.amazonaws.com/aygi_0012.jpeg",
  ];
  const [photoIndex, setPhotoIndex] = useState(0);
  const services = [
    {
      title: "Yacht Charter",
      content:
        "With AYGI: Experience Your flagship yacht brokerage for seamless buying and selling. ",
      image:
        "https://hcbyachts.com/wp-content/uploads/2024/08/DJI_0077-2-scaled.jpg",
    },
    {
      title: "Sea Trial",
      content:
        "AYGI secures flexible yacht financing through premier financial partnerships for you. ",
      image:
        "https://hcbyachts.com/wp-content/uploads/2024/08/DSC08432-copy-scaled.jpg",
    },
    {
      title: "Onboard Experience",
      content:
        "Insure your yacht seamlessly with tailored marine insurance from AYGI Insurance Broker. ",
      image:
        "https://hcbyachts.com/wp-content/uploads/2024/08/DJI_0095-Enhanced-NR-4-scaled.jpg",
    },
    {
      title: "Boat Rental",
      content:
        "We offer expert Yacht Transportation: land or water, your choice. ",
      image: "https://hcbyachts.com/wp-content/uploads/2022/02/DJI_0024.jpg",
    },
  ];
  const Location = [
    {
      title: "East Mediterranean",
      image:
        "https://cdn.pixabay.com/photo/2017/09/12/12/52/mediterranean-sea-2742232_1280.jpg",
    },
    {
      title: "West Mediterranean",
      image:
        "https://cdn.pixabay.com/photo/2019/09/02/09/57/royal-romance-yacht-4446932_1280.jpg",
    },
    {
      title: "North America",
      image:
        "https://cdn.pixabay.com/photo/2019/07/26/12/01/boat-4364637_1280.jpg",
    },
    {
      title: "The Bahamas",
      image:
        "https://cdn.pixabay.com/photo/2021/05/22/10/11/fishing-boat-6273132_1280.jpg",
    },
  ];
  return (
    <div>
      <NavBar />{" "}
      <div className="mob-banner d-md-none mb-4">
        <iframe
          src="https://player.vimeo.com/video/997919529?background=1"
          style={{
            position: "absolute",
            top: " 50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "177.77777778vh",
            height: "56.25vw",
            boxSizing: "border-box",
            minHeight: "100%",
            minWidth: "100%",
          }}
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen=""
          data-ready="true"
          title="hcb-video"
        ></iframe>
      </div>
      <div className="banner d-none d-md-block">
        <div className="banner-content">
          <iframe
            src="https://player.vimeo.com/video/997919529?background=1"
            frameBorder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowFullScreen
            title="hcb-video"
          ></iframe>
        </div>
      </div>
      <Container>
        <div className="py-4">
          <div class="col-lg-12 hr-line">
            <div class="d-flex justify-content-center">
              <div className="text-center">
                <h3 className="text-dark fw-bolder ">
                  "Your Dream Charter Vacation Starts Here"
                </h3>
                <p className="">
                  Welcome to American Yacht Group International, your trusted
                  source for booking private yacht vacations. Whether you’re
                  looking for a relaxing getaway in the Caribbean, a stylish
                  trip around the Mediterranean, or an adventure to a quiet
                  island, we’re here to make it easy.
                </p>
                <p className="pb-4">
                  Search all available yachts for rent, from fast motor yachts
                  to classic sailing boats. Our helpful destination guides will
                  give you ideas and tips for planning the perfect trip. And
                  when you're ready, we’ll connect you with an experienced
                  charter broker who will help you choose the best yacht and
                  plan every part of your journey.
                </p>
              </div>
            </div>
          </div>
          <Row>
            {Location.map((item, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
                <div className="yacht-tile">
                  <img src={item.image} alt={item.title} />
                  <div className="overlay">
                    <h3>{item.title}</h3>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          <div className="text-center mt-4">
            <h3 className="text-dark fw-bolder mb-3">
              "Explore Our Luxury Yacht for Charters"
            </h3>
          </div>
          <Card className="mb-3">
            <Row>
              <Col md={5}>
                <Card.Img
                  src="https://ayg.s3.us-east-2.amazonaws.com/WhatsApp+Image+2025-04-30+at+11.13.02+AM.jpeg"
                  alt="Card image"
                  style={{
                    height: "100%",
                    objectFit: "cover",
                    padding: "20px",
                  }}
                />
              </Col>
              <Col md={7}>
                <Card.Body>
                  <Card.Header as="h5" className="fw-bold ps-0 ms-0">
                    Yacht Charter Rates
                  </Card.Header>
                  <small>
                    <span>
                      <i className="fa-solid fa-bed"></i> 5 Rooms
                    </span>{" "}
                    <span>
                      <i className="fa-solid fa-people-group"></i> 12 Guests
                    </span>{" "}
                    <span>
                      <i className="fa-solid fa-ruler"></i> 100 Feet
                    </span>
                  </small>
                  <Table size="sm" className="mt-3">
                    <tbody>
                      <tr>
                        <td>
                          <strong>4 Hours</strong>
                        </td>
                        <td className="text-success">$6,000</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>8 Hours</strong>
                        </td>
                        <td className="text-success">$10,000</td>
                      </tr>
                      <tr>
                        <td>
                          <strong>Weekly Rate</strong>
                        </td>
                        <td className="text-success">$55,000</td>
                      </tr>
                    </tbody>
                  </Table>

                  <Card.Body>
                    <Button
                      className="btn-sm"
                      variant="primary"
                      onClick={() => setIsOpen(true)}
                    >
                      View Images
                    </Button>{" "}
                    <Button className="btn-sm" variant="warning">
                      Book Now
                    </Button>{" "}
                  </Card.Body>
                </Card.Body>
              </Col>
            </Row>
          </Card>
          <div className="p-4 bg-white rounded-3 shadow-sm mb-4">
            <Row className="g-0">
              <Col lg={4}>
                {" "}
                <Image
                  src="https://ayg.s3.us-east-2.amazonaws.com/AYGADS001.jpeg"
                  style={{
                    width: "300px",
                  }}
                />
              </Col>
              <Col md={8} className="">
                <div>
                  <h4 className="fw-bold mb-4">
                    <span className="border-warning border-bottom border-3">
                      Bernice Carmichael{" "}
                    </span>
                  </h4>
                  <p className="mb-1 pb-0">
                    Bernice Carmichael is a dedicated yacht charter professional
                    with extensive experience in managing personalized charter
                    experiences. As the former operations lead at LoveYachting,
                    LLC., she maintained a 95% client retention rate and earned
                    the Best of Getmyboat award in 2017 for exceptional service.
                    Known for her meticulous planning and strong network of
                    industry contacts, Bernice ensures each charter is
                    seamlessly executed and thoughtfully tailored. She doesn’t
                    just arrange voyages—she curates unforgettable moments that
                    leave a lasting impression.
                  </p>
                  <p className="fw-bold"> </p>
                  <small className="fw-bold text-wrap">
                    Bernice@americanyachtgroupinternational.com
                  </small>
                </div>
              </Col>
            </Row>
          </div>

          <div className="text-center"></div>
          <Row>
            {services.map((item, index) => (
              <Col key={index} xs={12} sm={6} md={4} lg={3} className="mb-4">
                <div className="yacht-tile">
                  <img src={item.image} alt={item.title} />
                  <div className="overlay">
                    <h3>{item.title}</h3>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
      <Container
        style={{ marginTop: "3rem", padding: "0 1rem", maxWidth: "1200px" }}
      >
        <Row>
          <Col xs={12} md={12} lg={5}>
            <div
              style={{
                borderRadius: "2.5rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                minHeight: "15rem",
                padding: "3rem",
                backgroundColor: "#fff",
                color: "#060633",
                boxShadow: "0 20px 30px -10px rgba(16,16,39,0.07)",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <h2
                  style={{
                    fontSize: "3.8rem",
                    fontWeight: 700,
                    lineHeight: "0.9",
                    color: "#3a3e61",
                    letterSpacing: "-2px",
                  }}
                >
                  Charter Service
                </h2>
                <p
                  style={{
                    fontWeight: 500,
                    fontSize: "1.2rem",
                    lineHeight: "1.3",
                    color: "#4b556b",
                  }}
                >
                  Experience true freedom, complete privacy, and an unparalleled
                  level of personalized service—an exclusive combination that
                  simply cannot be found anywhere on land. Whether you're
                  seeking ultimate relaxation, bespoke adventures, or discreet
                  luxury, this is a world designed entirely around you.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={12} lg={7}>
            <Row className="g-3">
              <Col xs={12}>
                <div
                  style={{
                    borderRadius: "2.5rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    minHeight: "15rem",
                    padding: "2rem",
                    backgroundImage:
                      "linear-gradient(-225deg, #fffeff 0%, #d7fffe 100%)",
                    color: "#060633",
                    boxShadow: "0 20px 30px -10px rgba(16,16,39,0.07)",
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <h2
                      style={{
                        fontSize: "3.8rem",
                        fontWeight: 700,
                        lineHeight: "0.9",
                        color: "#38a5a2",
                        letterSpacing: "-2px",
                      }}
                    >
                      Limitless adventures, endless fun
                    </h2>
                    <p
                      style={{
                        fontWeight: 500,
                        fontSize: "1.2rem",
                        lineHeight: "1.3",
                        color: "#4b556b",
                      }}
                    >
                      Go wherever you wish, whenever you choose.
                    </p>
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div
                  style={{
                    borderRadius: "2.5rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    minHeight: "15rem",
                    padding: "2rem",
                    backgroundImage:
                      "url('https://hcbyachts.com/wp-content/uploads/2021/12/03-2018-HydraSport-1053.jpeg')",
                    backgroundSize: "100%",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    boxShadow: "0 20px 30px -10px rgba(16,16,39,0.07)",
                    fontFamily: "'Inter', sans-serif",
                  }}
                ></div>
              </Col>
              <Col lg={6}>
                <div
                  style={{
                    borderRadius: "2.5rem",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    minHeight: "15rem",
                    padding: "2rem",
                    backgroundImage:
                      "linear-gradient(-225deg, #ffffff 0%, #dacceb 100%)",
                    color: "#060633",
                    boxShadow: "0 20px 30px -10px rgba(16,16,39,0.07)",
                    fontFamily: "'Inter', sans-serif",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "1rem",
                    }}
                  >
                    <h3
                      style={{
                        fontWeight: 600,
                        fontSize: "2.6rem",
                        color: "#8b5cca",
                        letterSpacing: "-2px",
                      }}
                    >
                      Deals
                    </h3>
                    <p
                      style={{
                        fontWeight: 500,
                        fontSize: "1.2rem",
                        lineHeight: "1.3",
                        color: "#4b556b",
                      }}
                    >
                      We now offer you more choices in more destinations
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row style={{ marginTop: "1rem" }}>
          <Col xs={12} md={12} lg={5}>
            <div
              style={{
                borderRadius: "2.5rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                minHeight: "15rem",
                padding: "2rem",
                backgroundImage:
                  "url('https://hcbyachts.com/wp-content/uploads/2021/11/65-Helm-Dining.jpeg')",
                backgroundSize: "100%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                boxShadow: "0 20px 30px -10px rgba(16,16,39,0.07)",
                fontFamily: "'Inter', sans-serif",
              }}
            ></div>
          </Col>
          <Col xs={12} md={12} lg={7}>
            <div
              style={{
                borderRadius: "2.5rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                minHeight: "15rem",
                padding: "2rem",
                backgroundColor: "#fff",
                color: "#060633",
                boxShadow: "0 20px 30px -10px rgba(16,16,39,0.07)",
                fontFamily: "'Inter', sans-serif",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                }}
              >
                <h2
                  style={{
                    fontSize: "4rem",
                    fontWeight: 700,
                    lineHeight: "0.9",
                    color: "#3a3e61",
                    letterSpacing: "-2px",
                    overflow: "hidden",
                  }}
                >
                  Best yachts in the finest destinations
                </h2>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Charters;
